import { Title, Body, Micro } from "@vds3/typography";
import React from "react";
import { useSelector } from "react-redux";
import { MarginSpacerM, MarginSpacerS } from "../../../../Checkout/styleTag";
import { CheckAEMBoolValue } from "../../../../../Common/CommonPlanTile/CommonPlanTile";
import i18next from "i18next";
import { Tooltip } from "@vds3/tooltips";

 const DueMonthlyPrint = (props) => {
    const getFloatCartResponse = useSelector((state) => state.CustomizeOrder.getFloatCartResponse);
    const servicesInCart = useSelector((state) => state.CustomizeOrder.servicesInCart)
    const installments = useSelector((state) => state.CheckoutPage.installments)

    const { headerInfo, BlueJeanInfo, dataInfo, phoneInfo, tvInfo, subTotals, otherServices, equipmentAndOnetimeCharges, equipmentAndOnetimeChargesTotal    , taxAndOtherCharges, subTotalequipmentAndOnetimeCharges } = getFloatCartResponse?.planDetails;         
    return (
        <div>
            {servicesInCart!="BDV"?<InternetSection {...getFloatCartResponse?.planDetails} showAutoPayTax={props?.showAutoPayTax || false} installments={installments || {}} autoPayCartInfo={props?.autoPayCartInfo || ""} {...props}/>:<></>}
            {getFloatCartResponse?.planDetails?.phoneInfo?<BDVInfo phoneInfo={phoneInfo}/>:<></>}
            <TVPlan tvInfo={tvInfo}/>
            <OtherService otherServices={otherServices} tvInfo={tvInfo}/>
            <EquipmentCharges {...getFloatCartResponse?.planDetails}/>
            <TaxAndOtherChanges taxAndOtherCharges={taxAndOtherCharges} headerInfo={headerInfo}/>
        </div>
    )
}

const InternetSection = ({ dataInfo,subTotals,offerInfo,showAutoPayTax,installments,autoPayCartInfo,...props}) => {
    let autopayEnrollCart = CheckAEMBoolValue(i18next.t("fios.autopayEnrollCart", { ns: "fios"}));
    let autopayBeforeEnroll = i18next.t("fios.autopayBeforeEnroll", { ns: "fios"}) || "";
    let autopayAfterEnroll = i18next.t("fios.autopayAfterEnroll", { ns: "fios"}) || "";
    let autopayTermApply = i18next.t("fios.autopayTermApply", { ns: "fios"}) || "";
    let jointOfferCartCSS = i18next.t("fios.jointOfferCartCSS", { ns: "fios",returnObjects:true});
    jointOfferCartCSS = jointOfferCartCSS instanceof Object ? jointOfferCartCSS : {fontSize:"0.9rem",color:"black"};
    let jointOfferWirelessCartCSS = i18next.t("fios.jointOfferWirelessCartCSS", { ns: "fios",returnObjects:true});
    jointOfferWirelessCartCSS = jointOfferWirelessCartCSS instanceof Object ? jointOfferWirelessCartCSS : {color:"black"};

    return (
        <>
            <Micro color="#6F7171">Internet service</Micro>
            <CommonSection left={"Estimated monthly charges."} right={" "} />
            <MarginSpacerM/>
            <Micro color="#6F7171">Internet Plan</Micro>
            <CommonSection left={dataInfo?.['planName']} right={dataInfo?.['planPrice']} />
            <MarginSpacerM />
            {autopayEnrollCart?
            <><span dangerouslySetInnerHTML={{__html:props?.IsAutoPayApplied === "Y" ? autopayAfterEnroll : autopayBeforeEnroll}}></span><Tooltip size="small" id="cart-without-autopay" header=" " surface="light" className={props?.IsAutoPayApplied === "Y" ? "checkout-cart-autopay-enrolled-tooltip" : "checkout-cart-autopay-tooltip"}>{autopayTermApply || ""}</Tooltip><MarginSpacerM /></>
            :<></>}
            {/* {showAutoPayTax && autoPayCartInfo && autoPayCartInfo !== "fios.autoPayCartInfo" && installments?.autoPay===true && installments?.paperFreeBilling===true?<>
            <span dangerouslySetInnerHTML={{__html:autoPayCartInfo}}></span>
            <MarginSpacerM/>
            </>:<></>} */}
            {offerInfo && offerInfo?.length>0?<>
            <Body size="large">{(offerInfo?.[0]?.['planName'])?(offerInfo?.[0]?.['planName'].includes("Ring Camera"))?<span style={{color:"blue"}}>{(offerInfo?.[0]?.['planName'])}</span>:(offerInfo?.[0]?.['planName']?.toLowerCase()?.includes("fios prepaid card") ? <span style={Object.keys(jointOfferCartCSS || {})?.length ? jointOfferCartCSS : {}}>{offerInfo?.[0]?.['planName']}</span> : (offerInfo?.[0]?.['planName']?.toLowerCase()?.includes("fios & business wireless offer") ? <span style={Object.keys(jointOfferWirelessCartCSS || {})?.length ? jointOfferWirelessCartCSS : {}}>{offerInfo?.[0]?.['planName']}</span> : offerInfo?.[0]?.['planName'])):""}</Body>
            <Body size="large">{(offerInfo?.[1]?.['planName'])?(offerInfo?.[1]?.['planName'].includes("Ring Camera"))?<span style={{color:"blue"}}>{(offerInfo?.[1]?.['planName'])}</span>:(offerInfo?.[1]?.['planName']?.toLowerCase()?.includes("fios prepaid card") ? <span style={Object.keys(jointOfferCartCSS || {})?.length ? jointOfferCartCSS : {}}>{offerInfo?.[1]?.['planName']}</span> : (offerInfo?.[1]?.['planName']?.toLowerCase()?.includes("fios & business wireless offer") ? <span style={Object.keys(jointOfferWirelessCartCSS || {})?.length ? jointOfferWirelessCartCSS : {}}>{offerInfo?.[1]?.['planName']}</span> : offerInfo?.[1]?.['planName'])):""}</Body>
            <MarginSpacerM/></>:<></>}
            <CommonSection left={"Subtotal internet Service"} right={subTotals?.['services']?.['price'] || ''} />
            <MarginSpacerM/>
        </>
    )
}
const BDVInfo = ({phoneInfo})=>{
    return(
        <>
            <Micro color="#6F7171">Business Digital Voice</Micro>
            <CommonSection left={phoneInfo?.['noOfLines']+" Lines"} right={" "} />
            {(phoneInfo?.['lines'] && phoneInfo?.['lines'].length) ? 
            phoneInfo['lines'].map(data=>(
            <CommonSection left={data?.['TN']+' - '+data?.['planName']} right={data?.['total']} />
            ))
            : <></>}
            {(phoneInfo?.['phoneServices'] && phoneInfo?.['phoneServices'].length) ?
            phoneInfo['phoneServices'].map(data=>(
            <CommonSection left={data['Name']} right={data?.['Rc']} />
            ))
            : <></>}
            <MarginSpacerM/>
        </>
    )
}

const TVPlan = ({tvInfo})=>{
    return(
        <>
        {tvInfo?<>
        <Micro color="#6F7171">TV Plan</Micro>
        <CommonSection left={tvInfo?.['planName']} right={tvInfo?.['planPrice']} />
        </>:<></>}
        </>
    )
}

const EquipmentCharges = ({equipmentAndOnetimeChargesTotal,equipmentAndOnetimeCharges,headerInfo})=>{
    return(
        <>
        <CommonSection left={"Total monthly charges"} right={headerInfo?.['Price']} bold/>
        <div style={{marginTop:'2rem'}}>
        <Micro color="#6F7171">Equipment and one-time charges</Micro>
        <CommonSection left="Equipment, activation and other fees can be billed over installments. You can make installment updates during checkout." right=" "/>
         <MarginSpacerM/>
         {(equipmentAndOnetimeCharges&&equipmentAndOnetimeCharges.length) ?
         equipmentAndOnetimeCharges.map(equip=>(
            <CommonSection left={equip?.offerName} right={equip?.price} microText={equip?.installmentOption}/>
         ))
         : <></>}
         <MarginSpacerM/>
        <CommonSection left={equipmentAndOnetimeChargesTotal?.subTotalequipmentAndOnetimeCharges?.Name} right={equipmentAndOnetimeChargesTotal?.subTotalequipmentAndOnetimeCharges?.price} bold/>
        <MarginSpacerM/>
        </div>
        </>
    )
}

const OtherService = ({ otherServices,tvInfo }) => {
    return (
        <div style={{marginTop:'1rem'}}>
            <Micro color="#6F7171">Other Service</Micro>
            {otherServices && otherServices.length ?
                otherServices.map(data => (
                        <CommonSection left={data['Product']} right={data['price']} />
                ))
                : <></>}
            {(tvInfo&&tvInfo['tvServices']&&tvInfo['tvServices'].length) ?
            tvInfo['tvServices'].map(data=>(
                <CommonSection left={data['prdName']} right={data['Price']} />
            ))
            : <></>}
            {(tvInfo && tvInfo['MovieChannelsPack'] && tvInfo.MovieChannelsPack?.length)?<>
                <CommonSection left={'Movie Channels Pack'} right={tvInfo['MoviechannelsPackPrice']??""} />
			    {tvInfo.MovieChannelsPack.map((item, i) => 
                    <CommonSection left={`- ${item["channelName"]}`} right={"Included"} />
                    )}
			</>:<></>}
        </div>
    )
}

const TaxAndOtherChanges = ({taxAndOtherCharges})=>{
    const { taxAndotherCharges } = taxAndOtherCharges || {}
    return(
        <>
        <Micro color="#6F7171">Taxes and other charges</Micro>
        <CommonSection left="Estimated taxes and other Verizon charges" right=" "/>
        {(taxAndotherCharges&&taxAndotherCharges.length) ? 
        taxAndotherCharges.map(data=>(
            <CommonSection left={data['offerName']} right={data['wavied'] ? 'Fee waived' : data['price']} microText={data['installmentOption'] ?? ""}/>
        ))
        : <></>}
        
        </>
    )
}


const CommonSection = ({ left = "", right = "",bold=false,microText="" }) => {
    return (
        <div style={{marginBottom:'10px'}}>
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', columnGap: '1rem' }}>
            <div style={{ width: '70%' }}>
                <Body size="large" bold={bold}>{left}</Body>
            </div>
            <div style={{ display:'flex',justifyContent:'flex-end' }}>
            <Body size="large" bold={bold}>{String(right).toLowerCase().includes('include') ? 'Included' : right}</Body>
            </div>
        </div>
        {microText ?
        <Micro color="#6F7171">{microText}</Micro>
        :<></>}
        </div>
    )
}


export default DueMonthlyPrint